import { debugMode } from "config";

export const logger = (message: string, debugOnly = false) => {
  if (debugOnly && !debugMode) {
    return;
  }

  console.log(message);
};
